export const addQueryParams = (params: { [key: string]: any }): string => {
  const { pathname, search } = window.location;

  const urlSearchParams = new URLSearchParams(search);

  Object.keys(params).forEach((param) => {
    urlSearchParams.set(param, params[param]);
  });

  return `${pathname}${urlSearchParams.toString() !== '' ? '?' : ''}${urlSearchParams}`;
};

export default addQueryParams;
